import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  ProvincePayloadSchema,
  provincePayloadSchema,
  useProvince,
} from "@/api/province";
import { Loading } from "@/components/ui/loading";
import { ProvinceFormFields } from "./ProvinceFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";

export function ProvinceDetailForm({ id }: { id: string }) {
  const {
    data: province,
    isPending: isLoadingData,
    isError,
  } = useProvince({
    id,
  });
  const form = useForm<ProvincePayloadSchema>({
    resolver: zodResolver(provincePayloadSchema),
    defaultValues: {
      provinceCode: province?.provinceCode,
      provinceName: province?.provinceName,
    },
    values: province,
  });

  if (isLoadingData) {
    return <Loading />;
  }

  if (!province) {
    return <div>Province not found</div>;
  }

  if (isError) {
    return <div>Failed to load province</div>;
  }

  return (
    <FormContainer form={form}>
      <ProvinceFormFields isDisabled />
      <div className="ml-auto">
        <Anchor href="/master-data/province" mood="axiata-blue">
          Back
        </Anchor>
      </div>
    </FormContainer>
  );
}
